import { StyleSheet } from 'react-native';
import config from '../../lib/config';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  flatList: {
    flex: 1,
    marginTop: 16,
  },
  ledgerLine: {
    flexDirection: 'row',
  },
  titleLedger: {
    fontSize: 15,
    fontWeight: 'bold',
    color: config.theme.headingTextColor,
    marginRight: 6,
    marginBottom: 4,
  },
  titleNoData: {
    fontSize: 15,
    fontWeight: 'bold',
    color: config.theme.headingTextColor,
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  labelLedger: {
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  ledgerItem: {
    marginHorizontal: 16,
    marginBottom: 8,
    padding: 16,
    borderRadius: 8,
  },
  headerLedgerItem: {
    marginBottom: 16,
    flexDirection: 'row',
  },
  footerLedgerItem: {
    marginTop: 16,
    flexDirection: 'row',
  },
  ledgerlabelCustomStyle: {
    flex: 1,
  },
  ledgerTitleCustomStyle: {
    flex: 2,
  },
  backgroundBrown: {
    backgroundColor: '#D9D8DC',
  },
  backgroundPlain: {
    backgroundColor: '#FFFFFF',
  },
  limitLineWidth: {
    width: 100,
  },
});
